import React from "react";
import { Tooltip } from "antd";
import { REPORT_GENERATION_STATUS } from "../../../../utils/statusConfig";

export default function ReportType({
  result,
}) {
  const status = REPORT_GENERATION_STATUS[result];
  const Icon = status?.icon;
  if (result === "complete") {
    return null;
  }
  return (
    <Tooltip title={status?.label}>
      <div style={status?.styles}>
        {Icon && <Icon />}
      </div>
    </Tooltip>
  );
}
